export default [

    {
        path: '',
        name: 'feedback',
        component: () => import('@/aplicacao/modulos/feedback/Listagem'),
        meta: { autenticacao: true },
    },

]
